import React from 'react';
import { Form } from 'react-bootstrap';

interface TextInputProps {
    id: string;
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    type?: 'text' | 'url' | 'email' | 'tel';
    placeholder?: string;
    required?: boolean;
    hasError?: boolean;
    className?: string;
}

export const TextInput: React.FC<TextInputProps> = ({
    id,
    name,
    value,
    onChange,
    onBlur,
    type = 'text',
    placeholder,
    required = false,
    hasError = false,
    className = ''
}) => {
    return (
        <Form.Control
            type={type}
            isInvalid={hasError}
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            required={required}
            className={className}
        />
    );
};
